import { useTranslation } from '@eti/providers';
import { Stack, Text, textVariants } from '@etg/wings';

const OrderChangeabilityNotAvailable = () => {
  const { t } = useTranslation();

  return (
    <Stack data-testid="order-changeability-not-available">
      <Text variant={textVariants._16_BOLD}>
        {t('OrderDetails.ManageTrip.NotChangeableTicket.Title')}
      </Text>
      <Text>{t('OrderDetails.ManageTrip.NotChangeableTicket.Description')}</Text>
    </Stack>
  );
};

export default OrderChangeabilityNotAvailable;
